module.exports = __webpack_public_path__ + "static/media/report_img2@2x.ef46d0d7.png";